import axios from "axios";

export const DownloadFile = async (url: string, name: string) => {
  // try {
  //   // // Fetch the PDF file from the remote URL
  //   // const response = await fetch(url);
  //   // const blob = await response.blob();

  //   // // Create a blob URL for the PDF
  //   // const blobUrl = URL.createObjectURL(blob);
  //   alert("Downloading file");
  //   // Create a link element
  //   const link = document.createElement("a");
  //   link.href = url;
  //   link.download = name; // Set the desired filename for the downloaded PDF
  //   link.click();

  //   // Clean up
  //   document.body.removeChild(link);
  // } catch (error) {
  //   console.error("Error downloading PDF:", error);
  // }
  // axios({
  //   url: url,
  //   method: "GET",
  //   responseType: "blob", // Important
  // })
  //   .then((response) => {
  //     const url = window.URL.createObjectURL(new Blob([response.data]));
  //     const link: any = document.createElement("a");
  //     link.href = url;
  //     link.setAttribute("download", name);
  //     document.body.appendChild(link);
  //     link.click();
  //     link.parentNode.removeChild(link);
  //   })
  //   .catch((error) => {
  //     console.error("Error downloading file:", error);
  //   });
  window.open(url, "_blank");
};
